window.q_dialog = function (id, title, content = '', actions, size) {
    $(`#modal_${id}`).remove();

    if (typeof actions == "undefined")
        actions = '<a href="#" data-bs-dismiss="modal" class="btn btn-primary modal-action modal-close">Ok</a>';

    if (size === 'seating-plan') {
        var q_modal_class = 'modal-seating-plan';
    } else {
        var q_modal_class = 'modal-quick';
    }

    $('body').append(
        `<div class="modal ${q_modal_class}" id="modal_${id}" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${title}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" ${content === '' ? 'style="display:none;"' : ''}>
                        <p>${content}</p>
                    </div>
                    <div class="modal-footer">
                        ${actions}
                    </div>
                </div>
            </div>
        </div>`
    );

    new bootstrap.Modal($(`#modal_${id}`)[0]).show()
}

window.toast = function (content = '', options = {theme: '', header: '', life: 0}) {
    const timestamp = +new Date()
    const template = $(
        `<div id="toast-${timestamp}" class="toast text-white ${options.theme} border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
                <strong class="me-auto">${options.header}</strong>
                <small class="text-muted"></small>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body">
                ${content}
            </div>
        </div>`
    )
    $('body .toast-container').append(template)
    const toast = bootstrap.Toast.getOrCreateInstance(template)
    toast.show()
    toast._element.addEventListener('hidden.bs.toast', function (e) {
        $(toast._element).remove()
    })
}